import React, { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';

const HeadersForm = ({ headers, setHeaders, formData, setFormData }) => {
    const [newHeaderKey, setNewHeaderKey] = useState('');
    const [newHeaderValue, setNewHeaderValue] = useState('');

    const handleAddHeader = () => {
        if (!newHeaderKey.trim() || !newHeaderValue.trim()) {
            toast.error('Header key and value are required');
            return;
        }
        if (headers.some(h => h.key === newHeaderKey)) {
            toast.error('Header key already exists');
            return;
        }
        const newHeaders = [...headers, { key: newHeaderKey.trim(), value: newHeaderValue.trim() }];
        setHeaders(newHeaders);
        setFormData(prev => ({ ...prev, headers: newHeaders }));
        setNewHeaderKey('');
        setNewHeaderValue('');
    };

    const handleDeleteHeader = (index) => {
        const newHeaders = headers.filter((_, i) => i !== index);
        setHeaders(newHeaders);
        setFormData(prev => ({ ...prev, headers: newHeaders }));
    };

    return (
        <Form.Group className="mt-3">
            <Form.Label>Headers</Form.Label>
            <div className="mb-2">
                <InputGroup>
                    <Form.Control
                        type="text"
                        placeholder="Header Key"
                        value={newHeaderKey}
                        onChange={(e) => setNewHeaderKey(e.target.value)}
                    />
                    <Form.Control
                        type="text"
                        placeholder="Header Value"
                        value={newHeaderValue}
                        onChange={(e) => setNewHeaderValue(e.target.value)}
                    />
                    <Button variant="primary" onClick={handleAddHeader}>
                        Add Header
                    </Button>
                </InputGroup>
            </div>
            {headers.length > 0 ? (
                <div className="border rounded p-2">
                    {headers.map((header, index) => (
                        <div key={index} className="d-flex align-items-center mb-2">
                            <div className="flex-grow-1">
                                <strong>{header.key}:</strong> {header.value}
                            </div>
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleDeleteHeader(index)}
                            >
                                <i className="fa fa-trash"></i>
                            </Button>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-muted">No headers added</div>
            )}
        </Form.Group>
    );
};

export default HeadersForm; 